import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedPlatSections } from '@hooks/mocks/platSections'
import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

interface IPlantSections {
  code: string
  description: string
  id: number
  isActive: boolean
  projectIds: number[]
}

export const useFindSitePlantSections = () => {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  const fetchSitePlantSections = async () => {
    if (!isMockEnvironment) {
      const url = `sites/${siteId}/plantSections`
      const { data } = await api.get<IPlantSections[]>(url)
      return data
    }
    return mockedPlatSections
  }
  return useQuery({
    queryKey: ['PLANT_SECTIONS'],
    queryFn: fetchSitePlantSections,
  })
}
